import dynamic from 'next/dynamic';
import VehicleDetailsStandardContainer from '@/vdp/VehicleDetailsContainer';
import { vdpStandardPage, vdpTrack } from '~/constants/eventable';
import VehicleDetailsProviders, {
  type VehicleDetailsProvidersProps
} from '~/context/vdp/VehicleDetailsProviders';
import getVehicleDetailsServerSideProps from '~/server-props/vdp/getVehicleDetailsServerSideProps';
import reduxWrapper from '~/store/configureStore';
import { ErrorBoundary } from '~/utilities/ErrorBoundary';

const MetaTags = dynamic(() => import('@/vdp/MetaTags'));
const TrackPageExit = dynamic(
  () =>
    import(
      /* webpackChunkName: "TrackPageExit" */ '@/vdp/Analytics/TrackPageExit'
    ),
  { ssr: false }
);

type OwnProps = {
  forProviders: VehicleDetailsProvidersProps;
};

export default function VehicleDetailsPage(props: OwnProps) {
  return (
    <ErrorBoundary>
      <VehicleDetailsProviders
        eventableProject={vdpStandardPage}
        eventableTrack={vdpTrack}
        {...props.forProviders}
      >
        <MetaTags />
        <TrackPageExit />
        <VehicleDetailsStandardContainer />
      </VehicleDetailsProviders>
    </ErrorBoundary>
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(
  store => context =>
    getVehicleDetailsServerSideProps({
      context,
      page: vdpStandardPage,
      store
    })
);
